import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import terms from '../content/terms';
import * as PD from '../classes/pdStyle';
import '../css/terms.css';

const TermsAndConditions = () => {
    const { version } = useParams();
    
    // If version specified in URL, find that version; otherwise use current
    const displayVersion = version 
        ? terms.versions.find(v => v.version === parseInt(version))
        : terms.current;
    
    if (!displayVersion) {
        return (
            <div>
                <PD.Heading>Terms and Conditions Not Found</PD.Heading>
                <PD.P>The requested version could not be found.</PD.P>
                <Link to="/terms">View current terms</Link>
            </div>
        );
    }
    
    const isCurrentVersion = displayVersion.version === terms.current?.version;
    
    return (
        <div className="terms-container">
            <PD.Heading>Terms and Conditions</PD.Heading>
            
            {!isCurrentVersion && (
                <div className="terms-notice">
                    <strong>Note:</strong> You are viewing version {displayVersion.version} 
                    (effective {displayVersion.effectiveDate}). 
                    <Link to="/terms"> View current version</Link>
                </div>
            )}
            
            <div className="terms-metadata">
                <p><strong>Version:</strong> {displayVersion.version}</p>
                <p><strong>Effective Date:</strong> {displayVersion.effectiveDate}</p>
                <p><strong>Organization:</strong> {terms.config.organizationName}</p>
            </div>
            
            <div className="terms-content">
                <ReactMarkdown>{displayVersion.content}</ReactMarkdown>
            </div>
            
            {terms.versions.length >= 1 && (
                <div className="terms-history">
                    <h2>All Versions</h2>
                    <ul>
                        {terms.versions.map(v => (
                            <li key={v.version}>
                                {v.version === displayVersion.version ? (
                                    <span className="terms-version-current">
                                        Version {v.version} - Effective {v.effectiveDate} (Current)
                                    </span>
                                ) : (
                                    <Link to={`/terms/v${v.version}`}>
                                        Version {v.version} - Effective {v.effectiveDate}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default TermsAndConditions;
